import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../types';
import { ISchoolTransportationFilterParams } from '../../types';
import {
  getAllSchoolTransportationByLicenseAsync,
  getAllSchoolTransportationCountAsync,
} from '../../index';

export const SCHOOL_TRANSPORTATION_KEYS = {
  ALL: 'schoolTransportation',
  LIST: 'list',
  COUNT: 'count',
};

export const useGetAllSchoolTransportationByLicenseQuery = (
  pagination: IPaginationParams,
  filter: ISchoolTransportationFilterParams
) => {
  return useQuery(
    [SCHOOL_TRANSPORTATION_KEYS.ALL, SCHOOL_TRANSPORTATION_KEYS.LIST, pagination, filter], 
    () => getAllSchoolTransportationByLicenseAsync(pagination, filter),
    {
      keepPreviousData: true, 
      refetchOnWindowFocus: false, 
      staleTime: 1000 * 60,
    }
  );
};

export const useGetSchoolTransportationCountQuery = (
  filter: ISchoolTransportationFilterParams
) => {
  return useQuery(
    [SCHOOL_TRANSPORTATION_KEYS.ALL, SCHOOL_TRANSPORTATION_KEYS.COUNT, filter],
    () => getAllSchoolTransportationCountAsync(filter),
    {
      keepPreviousData: true, 
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};
